export const CARDS_GUTTER = 16
